var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.qualification)?_c('div',[_c('SIcon',{staticClass:"mb-1 mr-1",attrs:{"icon":_vm.icon,"size":"small","color":"iconNeutral"}}),_c('span',_vm._b({},'span',_vm.$attrs,false),[_vm._v(_vm._s(_vm.$t(`common.words.${_vm.qualification}`))+" "+_vm._s(_vm.$t('common.words.data_usage')))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }